import React from 'react'
import { connect } from 'react-redux'
import { Layout, Menu, Button } from 'antd'
import { view as Logout } from '../modules/auth/logout/'
import { Link } from 'react-router-dom'
import { changeLang } from '../universal/actions'

const { Header } = Layout
const MenuItem = Menu.Item

class HomeHeader extends React.Component {
  // constructor() {
  //   super()
  //   this.state = {
  //     ispc: this.isPC(),
  //   }
  // }
  // isPC() {
  //   const userAgentInfo = navigator.userAgent
  //   const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
  //   let flag = true
  //   for(let v = 0; v < Agents.length; v++) {
  //     if(userAgentInfo.indexOf(Agents[v]) > 0) {
  //       flag = false
  //       break
  //     }
  //   }
  //   return flag
  // }
  render() {
    const { ispc } = this.props
    return (
      <Header className="home-layout-header">
        {!ispc ? null : <Link to="/home/user" className="logo-words">ShadowFog</Link>}
        <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
          <MenuItem disabled style={{padding: 0}} key="3"><Button onClick={() => this.props.onChangeLang('zh')}>中文</Button></MenuItem>
          <MenuItem disabled style={{padding: 0, marginLeft: 10, marginRight: 20}} key="4"><Button onClick={() => this.props.onChangeLang('en')}>English</Button></MenuItem>
          <MenuItem key="1">Dashboard</MenuItem>
          <MenuItem key="2"><Logout /></MenuItem>
        </Menu>
      </Header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ispc: state.auth.isPC
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeLang: (data) => {
      dispatch(changeLang({
        data,
      }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader)



// WEBPACK FOOTER //
// ./src/common/header.js